/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Note_Default_TitleInputs */

const en_toast_note_default_title = /** @type {(inputs: Toast_Note_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio note`)
};

const es_toast_note_default_title = /** @type {(inputs: Toast_Note_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota de audio`)
};

/**
* | output |
* | --- |
* | "Audio note" |
*
* @param {Toast_Note_Default_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const toast_note_default_title = /** @type {((inputs?: Toast_Note_Default_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Note_Default_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_toast_note_default_title(inputs)
	return en_toast_note_default_title(inputs)
});